<template>
  <div>
    <div class="kit__utils__heading text-center">
      <h5>
        <span class="mr-3">Profile</span>
      </h5>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-9">
        <div class="card">
          <div class="card-body">
            <profile-1 />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      Need help? Email us at:
    </div>
    <div class="row justify-content-center">
      <a :href="`mailto:${supportEmail}`">
        {{ supportEmail }}
      </a>
    </div>
  </div>
</template>
<script>
import profile1 from '@/components/profile/profile1'

export default {
  components: {
    profile1,
  },
  data() {
    return {
      supportEmail: 'support@nursingexampro.com',
      activeKey: '1',
      form: this.$form.createForm(this),
    }
  },
  methods: {
    callback: function (key) {
      this.activeKey = key
    },
  },
}
</script>
